const REGEX = {
	// eslint-disable-next-line no-useless-escape
	atLeastOneCharacterValidator: /^(?=.*[^ ])..*$/,
	emailFormatValidator: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
	textFormatValidator: /^[a-zA-ZÀ-ÿ\s]{2,150}$/,
	passwordFormatValidator:
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&-_])([A-Za-z\d$@$!%*?&-_]|[^ ]){8,15}$/,
	phoneFormatValidator: /^\d{8,11}$/,
	docTypeValidator: /\b[1-6]\b/,
	cuitFormatValidator: /^[A-Za-z0-9]{7,11}$/,
	lettersAndNumbersValidator: /^[0-9a-zA-ZÀ-ÿ\s.]+$/,
	zipCode: /^\d{4,5}$/,
	floorAndApartment: /^[A-Za-z0-9\s]*$/g,
	transpoValidator: /^[0-9a-zA-ZÀ-ÿ\s-]+$/,
};

export default REGEX;
